
import React, { useState, useEffect } from 'react';
import { useToast } from '@/hooks/toast/index';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';

export const UpdateNotification: React.FC = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const { toast } = useToast();

  useEffect(() => {
    // Listen for service worker updates
    const handleMessage = (event: MessageEvent) => {
      if (event.data && event.data.type === 'CACHE_UPDATED') {
        setUpdateAvailable(true);
        toast({
          title: "Përditësim i disponueshëm",
          description: "Një version i ri i aplikacionit është i disponueshëm. Rifreskoni faqen për të marrë veçoritë më të reja.",
          action: (
            <Button
              variant="outline"
              size="sm"
              onClick={() => window.location.reload()}
              className="flex items-center gap-2"
            >
              <RefreshCw className="w-4 h-4" />
              Rifreskon
            </Button>
          ),
          duration: 10000, // Show for 10 seconds
        });
      }
    };

    navigator.serviceWorker?.addEventListener('message', handleMessage);

    // Check for updates when the page becomes visible again
    const handleVisibilityChange = () => {
      if (!document.hidden && navigator.serviceWorker?.controller) {
        navigator.serviceWorker.controller.postMessage({ type: 'CHECK_UPDATE' });
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      navigator.serviceWorker?.removeEventListener('message', handleMessage);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [toast]);

  return null; // This component only handles notifications, no UI
};
